// 获取文档图标
function getFileIcon (fileType, fn, url) {
  // console.log('url', url, fileType, fn)
  switch (fileType) {
    case 'Image':
      if (url != null) {
        return url
      } else {
        return require('../assets/file_icon/icon_tupian@2x.png')
      }
    case 'Audio':
      return require('../assets/file_icon/icon_yinpin@2x.png')
    case 'Video':
      return require('../assets/file_icon/icon_shipin2@2x.png')
    default:
      if (fn) {
        let fns = fn.split('.') // 获取截取的最后一个元素 ，判断后缀名字
        if (fns.slice(-1) == 'doc' || fns.slice(-1) == 'docx') {
          return require('../assets/file_icon/icon_doc@2x.png')
        } else if (fns.slice(-1) == 'xls' || fns.slice(-1) == 'xlsx') {
          return require('../assets/file_icon/icon_exc@2x.png')
        } else if (fns.slice(-1) == 'ppt' || fns.slice(-1) == 'pptx') {
          return require('../assets/file_icon/icon_ppt@2x.png')
        } else if (fns.slice(-1) == 'pdf') {
          return require('../assets/file_icon/icon_pdf@2x.png')
        } else if (fns.slice(-1) == 'rar' || fns.slice(-1) == 'zip') {
          return require('../assets/file_icon/icon_rar@2x.png')
        } else if (fns.slice(-1) == 'txt') {
          return require('../assets/file_icon/icon_txt@2x.png')
        } else if (fns.slice(-1) == 'jpg' || fns.slice(-1) == 'png' || fns.slice(-1) == 'jpeg') {
          if (url == '' || url == undefined || url == null) {
            // console.log('icon_tupian')
            return require('../assets/file_icon/icon_tupian@2x.png')
          } else {
            return url
          }
        } else {

        }
      }
  }
  return require('../assets/file_icon/icon_file.png')
}

// 获取档案级别图标
function getSecretgradeIcon (secretgrade) {
  if (secretgrade == 1) {
    return require('../assets/diyiji.png')
  } else if (secretgrade == 2) {
    return require('../assets/dierji.png')
  } else if (secretgrade == 3) {
    return require('../assets/disanji.png')
  }
}

// 设置默认头像
function getLogo (logoUrl) {
  if (logoUrl) {
    return logoUrl
  } else {
    return require('../assets/avatar.png')
  }
}
export {
  getFileIcon,
  getSecretgradeIcon,
  getLogo
}



// WEBPACK FOOTER //
// ./src/api/unifyIcon.js